module.exports = __webpack_public_path__ + "static/media/blurbBorder.98880088.svg";